import React, { Component } from "react"
import PropTypes from "prop-types"
import "./Popover.css"

export default class Popover extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: this.props.initiallyVisible
    }
  }

  render() {
    let visibilityClass = this.state.visible
      ? "Popover--active"
      : "Popover--inactive"
    let popoverClass = `Popover__content Popover--${this.props.position} ${visibilityClass}`
    return (
      <div
        className="Popover"
        onMouseEnter={() => {
          this.setState({ visible: true })
        }}
        onMouseLeave={() => {
          this.setState({ visible: false })
        }}
      >
        <div>{this.props.children}</div>
        <div className={popoverClass}>{this.props.content}</div>
      </div>
    )
  }
}
Popover.propTypes = {
  content: PropTypes.node,
  children: PropTypes.node,
  position: PropTypes.string,
  initiallyVisible: PropTypes.bool
}
Popover.defaultProps = {
  initiallyVisible: false
}
